import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FileStorageInjectionToken, FileStorageServiceInterface } from '../../interfaces/file-storage.interface';
import { AddressModel, AddressModelFromJson, JsonAddressModel } from '../../models/complex/address.model';

export const ADDRESSES_KEY = 'addressCollection';

@Injectable({
    providedIn: 'root',
})
export class StorageAddressService {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        @Inject(FileStorageInjectionToken) private readonly fileStorageService: FileStorageServiceInterface,
    ) {}

    public getAddresses(): Observable<AddressModelFromJson[]> {
        return this.fileStorageService.loadCompressedData<JsonAddressModel[]>(ADDRESSES_KEY).pipe(
            map((jsonAddresses) => jsonAddresses.map((jsonAddress) => new AddressModelFromJson(jsonAddress))),
            catchError((error) => {
                this.log.debug(
                    'StorageAddressService: getAddresses: Retrieving addresses from storage was not possible: ',
                    error,
                );
                return of([]);
            }),
        );
    }

    public saveAddresses(addresses: AddressModel[]): Observable<void> {
        return this.fileStorageService.storeCompressedData(ADDRESSES_KEY, addresses).pipe(map(() => undefined));
    }
}
